
import CODE from './qrcode.vue'
 
var $vm1
export default {
  install (Vue, options) {
    if (!$vm1) {
      const CODEPlugin = Vue.extend(CODE)
      $vm1 = new CODEPlugin().$mount()
      document.body.appendChild($vm1.$el)
    }
    Vue.prototype.$showCODE = function (data,state) {
      $vm1.showCODE(data,state)
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/paging/pcClient/sundryModule/qrcode/index.js